import { Component, Input } from '@angular/core';

@Component({
    selector: 'dbm-circle-progress-bar',
    template: require('./dbm-circle-progress-bar.component.html'),
    styles: [require('./dbm-circle-progress-bar.component.scss')]
})
export class DbmCircleProgressBarComponent {

    @Input() public circleSize: number = 30;
    @Input() public value: number = 0;

    constructor() {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-circle-progress-bar/dbm-circle-progress-bar.component.ts